import { memo, Fragment } from "react";

import classes from "./DrinkIngredients.module.css";

// component lists ingredients for cocktail
const DrinkIngredients = (props) => {
  const ingredients = props.ingredients.map((ing, index) => {
    return (
      <div key={index} className={classes.drink_ingredient}>
        <div>
          {ing.ingredient.title}
        </div>
        <div>
          {ing.volume} {ing.ingredient.unit}
        </div>
      </div>
    );
  });

  return (
    <Fragment>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.drink_ingredients}>{ingredients}</div>
    </Fragment>
  );
};

export default memo(DrinkIngredients);
